import { StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createStatusChartViewStyles = (theme: any) =>
  StyleSheet.create({
    wrapper: {
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      width: Typography.width.width219,
      height: Typography.height.height219,
    },
    innerWrapper: {
      // borderStyle: 'solid',
      // borderWidth: Typography.borderWidth.sm,
      // borderColor: '#0000000D',
      // borderRadius: 107,
      // padding: 3
    },
    tooltipContainer: {
      position: 'absolute',
      shadowOpacity: 0.26,
      shadowOffset: { width: 0, height: Typography.height.height4 },
      shadowColor: theme.statusPieChartBorderShadow,
      elevation: 8,
      shadowRadius: 8,
      height: Typography.height.height40,
    },
    tooltipBox: {
      backgroundColor: theme.statusPieChartToolTipBG,
      padding: Typography.padding.padding12,
      borderRadius: Typography.radius.radius4,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },
    tooltipText: {
      color: theme.statusPieChartToolTipText,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
    },
    arrowDown: {
      // backgroundColor: 'transparent',
      // borderStyle: 'solid',
      // borderTopWidth: Typography.borderWidth.xxxxl,
      // borderRightWidth: Typography.borderWidth.spacing5,
      // borderBottomWidth: 0,
      // borderLeftWidth: Typography.borderWidth.spacing5,
      // borderTopColor: theme.statusPieChartToolTipBG,
      // borderRightColor: 'transparent',
      // borderBottomColor: 'transparent',
      // borderLeftColor: 'transparent',
      alignSelf: Typography.textAlign.centerAlign,
    },
    arrowUp: {
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderBottomWidth: Typography.borderWidth.borderWidth10,
      borderRightWidth: Typography.borderWidth.borderWidth5,
      borderTopWidth: 0,
      borderLeftWidth: Typography.borderWidth.borderWidth5,
      borderBottomColor: theme.statusPieChartToolTipBG,
      borderRightColor: 'transparent',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent',
      alignSelf: Typography.textAlign.centerAlign,
      position: Typography.position.absolute,
      bottom: 40,
    },
    container: { alignItems: 'center', justifyContent: 'center' },
    chartWrapper: { width: Typography.width.width220, height: Typography.height.height219 },
  });
